import { BlockPanelProps } from "../../lib/register-block";
import PanelContainer from "../../lib/panel/panel-container";
import PanelInlineContent from "../../lib/panel/panel-inline-content";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { useTranslation } from "react-i18next";
import type { CrossSellBlock, CrossSellBlockProps } from "./types";

function PanelCrossCount() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<CrossSellBlockProps>();
  const count = blockProps.block.properties?.count ?? 2;

  return (
    <PanelInlineContent
      title={t(
        "editorBlocksLibrary.blocks.cross-sell.panel.count.title",
        "Products",
      )}
    >
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={String(count)}
        onValueChange={(value) => {
          const num = parseInt(value, 10) as 1 | 2 | 3 | 4;
          if (num >= 1 && num <= 4) {
            blockProps.formAPI.updateField<CrossSellBlock>(blockProps.formAPI.blockPath, {
              ...blockProps.block,
              properties: { ...blockProps.block.properties, count: num },
            });
          }
        }}
      >
        {([1, 2, 3, 4] as const).map((n) => (
          <ToggleGroupItem key={n} value={String(n)} aria-label={`${n} products`}>
            <span className="text-xs font-medium">{n}</span>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </PanelInlineContent>
  );
}

// Intent selector commented out for V1 — defaulting to COMPLEMENTARY
// function PanelCrossIntent() {
//   const { t } = useTranslation("editor-blocks-library");
//   const blockProps = useBlockPanelPropsContext<CrossSellBlockProps>();
//   const intent = blockProps.block.properties?.intent ?? "COMPLEMENTARY";
//
//   return (
//     <PanelInlineContent
//       title={t("editorBlocksLibrary.blocks.cross-sell.panel.intent.title", "Type")}
//     >
//       <ToggleGroup
//         variant="default"
//         type="single"
//         className="bg-background border shadow"
//         value={intent}
//         onValueChange={(value) => {
//           if (value === "RELATED" || value === "COMPLEMENTARY") {
//             blockProps.formAPI.updateField<CrossSellBlock>(blockProps.formAPI.blockPath, {
//               ...blockProps.block,
//               properties: { ...blockProps.block.properties, intent: value },
//             });
//           }
//         }}
//       >
//         <ToggleGroupItem value="RELATED" aria-label="Related products">
//           <span className="text-xs font-medium">
//             {t("editorBlocksLibrary.blocks.cross-sell.panel.intent.related", "Related")}
//           </span>
//         </ToggleGroupItem>
//         <ToggleGroupItem value="COMPLEMENTARY" aria-label="Complementary products">
//           <span className="text-xs font-medium">
//             {t("editorBlocksLibrary.blocks.cross-sell.panel.intent.complementary", "Complementary")}
//           </span>
//         </ToggleGroupItem>
//       </ToggleGroup>
//     </PanelInlineContent>
//   );
// }

export function CrossSellEmailPanelRenderer(
  blockProps: BlockPanelProps<CrossSellBlockProps>,
) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelCrossCount />
      {/* <PanelCrossIntent /> — commented out for V1 */}
      <PanelTranslationState mode="not-translatable" portal />
    </PanelContainer>
  );
}
